export default "__VITE_ASSET__BzJSg9DH__"